import axios from 'axios'

const systemFunction = {
    login: function(url, callback) {
        axios({
            method: 'GET',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            url: url
        }).then(respData => {
            if (respData && respData.data && respData.data.code && (respData.data.code === '302')) {
                location.href = respData.data.data
            } else {
                callback && callback()
            }
        }).catch(resp => {

        })
    },
    /**
     * 数据交互
     * @param _this
     * @param businessType
     * @param handleType
     * @param data
     * @param dataType
     * @param callback
     */
    interactiveData: function(_this, businessType, handleType, data, dataType, callback, errorback) {
        // 基本校验========start====================
        if (typeof _this === 'undefined') {
            alert('this参数未传，请联系管理员处理～')
            return
        }
        if (typeof businessType === 'undefined') {
            _this.$message({
                showClose: true,
                message: '业务模块参数未传～',
                type: 'warning'
            })
            return
        }
        if (typeof handleType === 'undefined') {
            _this.$message({
                showClose: true,
                message: '操作类型参数未传～',
                type: 'warning'
            })
            return
        }
        // 基本校验========end++====================
        const baseService = data.baseService
        delete data.baseService
        const paramsInfo = {
            type: handleType,
            info: data,
            baseService: baseService
        }
        const paramsInfos = {
            type: handleType,
            infos: data,
            baseService: baseService
        }
        _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business[businessType],
            (dataType ? paramsInfos : paramsInfo),
            resultData => {
              console.log(resultData)
                if (resultData.code === '200') {
                    callback && callback(resultData)
                } else {
                    errorback && errorback()
                    _this.$message({
                        showClose: true,
                        message: resultData.errorMsg,
                        type: 'warning'
                    })
                }
            },
            (e) => {
                errorback && errorback(e)

                _this.$message({
                    showClose: true,
                    message: '请求异常，请联系管理员～',
                    type: 'error'
                })
            }
        )
    },
    jsonPost: (url, params, callback, errorback) => {
        params.userInfo = {user: JSON.parse(localStorage.getItem('gcUserInfo'))}
        url && axios({
            method: 'POST',
            headers: {
                'Content-type': 'application/json;charset=UTF-8'
            },
            url: url,
            data: JSON.stringify(params)
        }).then(resp => {
            callback && callback(resp.data)
        }).catch(resp => {
            if (resp && resp.response && resp.response.status) {
                switch (resp.response.status) {
                    case 400:
                        break
                    default:
                        errorback && errorback(resp)
                }
            } else {
                errorback && errorback(resp)
            }
        })
    },
    formPost: (url, params, callback, errorback) => {
        url && axios({
            method: 'POST',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            url: url,
            data: params
        }).then(resp => {
            callback && callback(resp.data)
        }).catch(resp => {
            if (resp && resp.response && resp.response.status) {
                switch (resp.response.status) {
                    case 400:
                        break
                    default:
                        errorback && errorback(resp)
                }
            } else {
                errorback && errorback(resp)
            }
        })
    },
    commonGet: (url, callback, errorback) => {
        url && axios({
            method: 'GET',
            headers: {
                'Content-type': 'application/x-www-form-urlencoded'
            },
            url: url
        }).then(resp => {
            callback && callback(resp.data)
        }).catch(resp => {
            errorback && errorback(resp)
        })
    },
    downloadGet: (url, callback, errorback) => {
        url && axios({
            method: 'GET',
            headers: {
                'Content-type': 'application/json;charset=UTF-8'
            },
            url: url,
            responseType: 'arraybuffer'
        }).then(resp => {
            callback && callback(resp.data)
        }).catch(resp => {
            errorback && errorback(resp)
        })
    },
    getDictionary: (keyId, callback) => {

    },
    getConfigData: function(cacheType, keyId, callback, _this) {
        if (!localStorage.getItem(cacheType)) {
            _this.FUNCTIONS.systemFunction.getDictionary(keyId, data => {
                localStorage.setItem(cacheType, escape(JSON.stringify(data)))
                callback && callback(data)
            })
        } else {
            callback && callback(JSON.parse(unescape(localStorage.getItem(cacheType))))
        }
    },
    formatTime: function(number, format) {
        function formatNumber(n) {
            n = n.toString()
            return n[1] ? n : '0' + n
        }

        const formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
        const returnArr = []

        const date = new Date(number)
        returnArr.push(date.getFullYear())
        returnArr.push(formatNumber(date.getMonth() + 1))
        returnArr.push(formatNumber(date.getDate()))

        returnArr.push(formatNumber(date.getHours()))
        returnArr.push(formatNumber(date.getMinutes()))
        returnArr.push(formatNumber(date.getSeconds()))

        for (const i in returnArr) {
            format = format.replace(formateArr[i], returnArr[i])
        }
        return format
    },
    getConfigDataBatch: function(cfgList, _this) {
        cfgList.forEach(function(item) {
            _this.FUNCTIONS.systemFunction.getConfigData(item.data.listName, item.data.keyId, item.callback, _this)
        })
    },
    ages: function(str) {
        const r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
        if (r == null) return false
        const d = new Date(r[1], r[3] - 1, r[4])
        if (d.getFullYear() == r[1] && (d.getMonth() + 1) == r[3] && d.getDate() == r[4]) {
            const Y = new Date().getFullYear()
            return ('年龄   =   ' + (Y - r[1]) + '   周岁')
        }
        return ('输入的日期格式错误！')
    },
    // 清除对象中的空字符
    removeNullFields: function(entry) {
        for (const key in entry) {
            if (entry[key] !== 0 && entry[key] !== '0') {
                if (!entry[key]) {
                    delete entry[key]
                }
                if (entry[key] && entry[key].length === 0) {
                    delete entry[key]
                }
            }
        }
        return entry
    },
    // 分页参数设置
    paginationSet: function(currentPage, pageSize, infoData) {
        currentPage = currentPage || 1
        pageSize = pageSize || 10
        return {
            current: currentPage,
            size: pageSize,
            records: [infoData]
        }
    },
    /**
     * 获取字典数据
     * @param targetCode
     * @param listName
     * @returns {string}
     */
    getConfigValue: function(targetCode, listName) {
        let resultName = '--'
        const storageData = localStorage.getItem(listName)
        if (storageData) {
            const resultData = JSON.parse(unescape(storageData)) || []
            resultData.forEach(function(entry) {
                if (entry.code === targetCode) {
                    resultName = entry.name
                }
            })
        }
        return resultName
    },
    /**
     * 系统时间转换
     * @param _this， 系统this
     * @param object 需要转换的对象
     * @param fieldList 需要转换的字段
     * @returns {*}
     */
    dateFormatChange: function(_this, object, fieldList) {
        fieldList && (fieldList.length > 0) && fieldList.forEach(field => {
            if (
                typeof object[field] === 'number' ||
                typeof object[field] === 'string'
            ) {
                object[field] = _this.$moment(object[field])
            }
        })
        return object
    },
    timeToDate: function(_this, dateTime, formate) {
        return _this.$moment(dateTime).format(formate || 'YYYY-MM-DD')
    },
    /**
     * 判断两个日期大小 时间格式为 20201004000000
     * @param date1 开始日期
     * @param date2 结束日期
     * */
    compareDate: function(date1, date2) {
        let curTime = new Date()
        let startTime = new Date(Date.parse(date1))
        let endTime = new Date(Date.parse(date2))
        if (date1 > date2) {
            return false
        } else {
            return true
        }
    },
    /**
     * 导出
     * @param 当前vue
     * @param 请求参数集合
     *
     * */
    exportFunction: function(_this, params) {
        const date = new Date().getTime()
        let paramsStr = '?'
        for (const key in params) {
            paramsStr = paramsStr + key + '=' + params[key] + '&'
        }
        paramsStr = paramsStr + 'date=' + date
    },

    exportText: function(_this, params, model, template) {
        const keyArr = []
        const valueArr = []
        for (const key in params) {
            keyArr.push(key)
            valueArr.push(params[key])
        }
    },
    fileDownload: function(file) {
        (file && file.response && (file.response.code === '0') && file.response.data.fileUrl) ?
        window.open(encodeURI(file.response.data.fileUrl), '_blank'): this.$message.warning('下载参数有误～请联系管理员～')
    },
    fileTypeView: function(_this, file) {
        if ((file && file.response &&
                (file.response.code === '0') && file.response.data.fileType)) {
            switch (file.response.data.fileType) {
                case 'xls':
                case 'xlsx':
                case 'xlsm':
                case 'xltx':
                case 'xltm':
                case 'xlsb':
                case 'xlam':
                    return require('../../assets/image/file/excel.png')
                case 'doc':
                case 'docx':
                case 'docm':
                case 'dotx':
                case 'dotm':
                    return require('../../assets/image/file/word.png')
                case 'ppt':
                case 'pptx':
                case 'pptm':
                case 'ppsx':
                case 'potx':
                case 'potm':
                case 'ppam':
                    return require('../../assets/image/file/ppt.png')
                case 'pdf':
                    return require('../../assets/image/file/pdf.png')
                case 'bmp':
                case 'image':
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'gif':
                case 'pcx':
                case 'tiff':
                case 'svg':
                case 'psd':
                    return file.response.data.fileUrl
                default:
                    return require('../../assets/image/file/file.png')
            }
        }
    },
    postDownFile: function(_this, params) {
        axios({
            method: 'post',
            url: _this.CONFIG.urls.root + _this.CONFIG.urls.system.downFile,
            data: params,
            responseType: 'blob'
        }).then(response => {
            if (!response) {
                _this.$message.warn('返回数据为空')
            } else {
                const headers = response.headers
                const content = response.data
                const blob = new Blob([content])
                const fileName = headers.filename ? decodeURI(headers.filename) : 'nameNull'
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            }
        }).catch(() => {
            _this.$message.error('请求异常～请联系管理员')
        })
    },
    // post导出
    postDownFileurl: function(_this, params,url,name) {
        axios({
            method: 'post',
            url: url,
            data: params,
            responseType: 'blob'
        }).then(response => {
            if (!response) {
                _this.$message.warn('返回数据为空')
            } else {
                const headers = response.headers
                const content = response.data
                const blob = new Blob([content])
                // let contentDisposition = ''
                // let fileName = ''
                // if (!headers.filename) {
                //   contentDisposition = headers['content-disposition']
                //   if (contentDisposition) {
                //     fileName = decodeURI(decodeURI(headers['content-disposition'].split('=')[1], "UTF-8"))
                //   }
                // } else {
                //   fileName = headers.filename ? decodeURI(headers.filename) : 'nameNull'
                // }
                const fileName = headers.filename ? decodeURI(headers.filename) : name
                if ('download' in document.createElement('a')) { // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else { // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            }
        }).catch(() => {
            _this.$message.error('请求异常～请联系管理员')
        })
    },

    // 行政区划回显
    returnArea: function (val, option) {
      if(!val){
        return []
      }
      let arr = val.split(',') // 字符串分割成数组code
      // let radioValue = arr  // 多选值
      let temp = []
      // 对每一个选项进行重组
      for (let i = 0; i < arr.length; i++) {
        let nodeArr = fitData(arr[i])
        temp.push(nodeArr)
      }
      // 获取默认值并组装数据
      function fitData(data) {
        console.log(data)
        let arr = [] // 在递归时操作的数组
        let returnArr = [] // 存放结果的数组
        let depth = 0 // 定义全局层级
        function childrenEach(childrenData, depthN) {
          console.log(childrenData)
          for (let j = 0; j < childrenData.length; j++) {
            depth = depthN // 将执行的层级赋值 到 全局层级
            arr[depthN] = (childrenData[j].code)
            if (childrenData[j].code === data) {
              returnArr = arr.slice(0, depthN + 1) // 将目前匹配的数组，截断并保存到结果数组
              break
            } else {
              if (childrenData[j].children) {
                depth++
                childrenEach(childrenData[j].children, depth)
              }
            }
          }
          return returnArr
        }
        return childrenEach(option, depth)
      }
      console.log(temp)
      return temp
    },
    // 敏感信息加*显示
    returnStarInfo: function (start, end, info) {
        if (info === '' || info === null || info === undefined || info === 'undefined') {
            return ''
        } else {
            let old_str = info;
            let str = old_str.substring(0, start) + '****' + old_str.substring(end)
            return str
        }
    }

}

export default {
    systemFunction
}



// WEBPACK FOOTER //
// ./src/assets/js/functions.js